import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
};
export const Card = forwardRef(({ padding = 'none', hoverable = false, children, className, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('rounded-lg border border-dark-200 dark:border-dark-700 bg-white dark:bg-dark-800 shadow-card overflow-hidden', hoverable && 'transition-shadow duration-200 hover:shadow-elevated cursor-pointer', paddingClasses[padding], className), ...props, children: children }));
});
Card.displayName = 'Card';
export const CardHeader = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('px-4 py-3 border-b border-dark-200 dark:border-dark-700', className), ...props, children: children }));
});
CardHeader.displayName = 'CardHeader';
export const CardBody = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('px-4 py-4', className), ...props, children: children }));
});
CardBody.displayName = 'CardBody';
export const CardFooter = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('px-4 py-3 border-t border-dark-200 dark:border-dark-700 bg-dark-50 dark:bg-dark-800/50', className), ...props, children: children }));
});
CardFooter.displayName = 'CardFooter';
//# sourceMappingURL=Card.js.map